(function () {
    'use strict';

    angular
        .module('app')
        .controller('BuyReadyOverrideController', BuyReadyOverrideController);

    function BuyReadyOverrideController($scope, $rootScope, $location, $window, $state, $filter, $stateParams, UserService, toaster, PrototypeService) {
        var model = this;
        model.buyReadyReport = [];
        model.stockNumber = "";
        model.factoryKey = "";
        model.buyReady = false;
        model.prototypeSeasonalId = "";
        model.buyReadyOverrides = [];

        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] === 18) {
                if (userPermissionRow[1] === 1) {
                    model.SystemMessageRead = true;
                }
            }
        });

        if (!model.SystemMessageRead) {
            $state.go("permissionDenied");
        }

        //get buy ready overrides
        model.getBuyReadyOverrides = function (searchString) {
            if (!searchString) {
                searchString = "";
            }
            PrototypeService.buyReadyOverrides("", "", searchString).then(function (response) {
                if (response) {
                    model.buyReadyOverrides = response;
                }
            },
            function (error, status) {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'Buy Ready Overrides Error',
                    timeout: 5000
                });
            });
        }

        model.getBuyReadyOverrides();

        model.addBuyReadyOverride = function (id, b, c, d) {
            //id, stocknum, factnameky, buyready
            if (!b || !c || b == "" || c == "") {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'Stock Number or Factory Missing',
                    timeout: 5000
                });
                return;
            }
            model.updateOrAdd = id ? 'updated' : 'added';

            PrototypeService.buyReadyOverridesUpdate(id, b, c, d).then(function (response) {
                //reset values
                if (response.IsSuccessful) {
                    model.stockNum = "";
                    model.factoryKey = "";
                    model.buyReady = false;

                    toaster.pop({
                        type: 'success',
                        title: response.Message,
                        body: '',
                        timeout: 5000
                    });
                } else {
                    toaster.pop({
                        type: 'error',
                        title: 'Error!',
                        body: "There was an error adding or updating your Buy Ready Override",
                        timeout: 5000
                    });
                }

            },
            function (error, status) {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: "There was an error adding or updating your Buy Ready Override",
                    timeout: 5000
                });
            });
        }
    }
})();